<script>
    import { onMount, onDestroy } from 'svelte';
    import {
        finalType
    } from '../stores.js';

    export let onSearch;
    export let commandType;
    
    let query = '';
    let radius = 5; // Rayon par défaut de 30km
    let clientType = 'particulier'; // Type de client par défaut: particulier
    let searchInput;
    let autocomplete;
    let placesAPILoaded = false;

    if(commandType!='') {
        clientType = commandType;
    }
    
    onMount(() => {
    // Vérifier si Google Maps API est disponible
    const checkGoogleMapsAPI = setInterval(() => {
        if (window.google && window.google.maps && window.google.maps.places) {
        clearInterval(checkGoogleMapsAPI);
        // initAutocomplete();
        }
    }, 200);
    
    // On arrête de vérifier après 5 secondes
    setTimeout(() => {
        clearInterval(checkGoogleMapsAPI);
        if (!placesAPILoaded) {
        console.error("Google Places API n'a pas pu être chargée après 5 secondes");
        }
    }, 5000);
    });
    
    onDestroy(() => {
    // Nettoyage: supprimer les écouteurs d'événements
    if (autocomplete && google && google.maps && google.maps.event) {
        google.maps.event.clearInstanceListeners(autocomplete);
    }
    
    if (searchInput) {
        searchInput.removeEventListener('keydown', handleKeydown);
    }
    });
    
    function handleKeydown(e) {
    if (e.key === 'Enter' && document.activeElement === searchInput) {
        e.preventDefault();
    }
    }
    
    function initAutocomplete() {
    // Vérifier que l'élément DOM existe
    if (!searchInput) {
        console.error("L'élément input pour l'autocomplete n'est pas disponible");
        return;
    }
    
    try {
        // Initialiser l'autocompléteur Google Places
        // Restreindre aux résultats en France
        autocomplete = new google.maps.places.Autocomplete(searchInput, {
        types: ['(cities)'],
        componentRestrictions: { country: 'fr' }
        });
        
        // Empêcher le formulaire de se soumettre lorsqu'on appuie sur Entrée dans l'autocompléteur
        searchInput.addEventListener('keydown', handleKeydown);
        
        // Écouter l'événement place_changed
        autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        
        if (!place.geometry) {
            // L'utilisateur a appuyé sur Entrée dans l'autocompléteur
            // mais n'a pas sélectionné une suggestion
            return;
        }
        
        // Mettre à jour le champ de recherche avec le nom de la ville
        query = place.name;
        
        // Effectuer la recherche
        handleSearch();
        });
        
        placesAPILoaded = true;
    } catch (error) {
        console.error("Erreur lors de l'initialisation de l'autocomplete:", error);
    }
    }
    
    function handleSubmit(event) {
    event.preventDefault();
    handleSearch();
    }
    
    function handleSearch() {
    if (query.trim()) {
        // Passer le rayon de recherche et le type de client
        onSearch(query.trim(), radius, clientType);
    }
    }
</script>

<form on:submit={handleSubmit}>
    <div class="form-group">
    {#if commandType == ''}
        <div class="client-type-selector">
            <select id="client-type" bind:value={clientType} class="client-type-select as-input-neu">
            <option value="particulier">Particulier</option>
            <option value="professionnel">Professionnel</option>
            </select>
        </div>
    {:else}
        <input type="hidden" bind:value={clientType} />
    {/if}
    <input 
        type="text" 
        bind:value={query}
        bind:this={searchInput}
        placeholder="Entrez une ville ou un code postal" 
        class="as-input-neu"
    />
    
    <div class="radius-control">
        <label for="radius">Rayon de recherche: {radius} km</label>
        <input 
        type="range" 
        id="radius" 
        bind:value={radius} 
        min="5" 
        max="30" 
        step="5" 
        class="radius-slider"
        />
        <div class="radius-labels">
        <span>5km</span>
        <span>15km</span>
        <span>30km</span>
        </div>
    </div>
    
    <button type="submit" class="as-btn-rounded">Rechercher</button>
    </div>
    
    <!-- {#if !placesAPILoaded}
    <div class="api-warning">
        Chargement de l'autocomplétion...
    </div>
    {/if} -->
</form>

<style>
    .as-input-neu {
        background: #fff;
    }
    .as-btn-rounded {
    margin-top: 20px;
    padding: 12px 45px;
    }
    @media only screen and (max-width: 768px) {
        .as-btn-rounded {
        margin-top: 5px;
        margin-bottom: 20px;
        }
    }
    .form-group {
        display: flex;
        flex-direction: column;
        gap: 15px;
    }

    .search-input {
        padding: 10px;
        border: 1px solid #ccc;
        border-radius: 4px;
        font-size: 16px;
    }

    .radius-control {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    .radius-control label {
        font-size: 14px;
        color: #333;
    }

    .radius-slider {
        width: 100%;
        cursor: pointer;
        accent-color: #000;
    }

    .radius-labels {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        color: #666;
    }

    .search-button {
        padding: 10px;
        background-color: #4CAF50;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 16px;
    }

    .search-button:hover {
        background-color: #45a049;
    }

    .api-warning {
        margin-top: 10px;
        color: #856404;
        background-color: #fff3cd;
        padding: 8px;
        border-radius: 4px;
        font-size: 14px;
    }

    /* Styles pour l'autocomplétion Google Places (sélecteurs globaux) */
    :global(.pac-container) {
        border-radius: 4px;
        margin-top: 2px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    }

    :global(.pac-item) {
        padding: 8px;
        cursor: pointer;
    }

    :global(.pac-item:hover) {
        background-color: #f5f5f5;
    }
</style>